import "../src/global/global-pc"
import "@modules/_components/HTMLDynamicListElement"
import "@modules/advert-cards/advert-cards"

import "@modules/browser-extension/open-with-gesamt-icons.css"

import "@modules/vue-modals/ad-free.js"
import "@modules/vue-modals/coins"
import "@modules/vue-modals/age-verification.js"
import "@modules/location/LocationSelector"
import "@modules/solads/solads"
import "@modules/single-page/pc.css"
import "@modules/single-page/gallery/gallery.css"
import "@modules/bookmarks/advert-page/bookmark-tags.css"
import "@modules/single-page/single-page-pc.css"
import "@modules/single-page/crawler-protection/crawler-protection-pc.css"
import "@modules/single-page/single-page.js"
import "@modules/stars/stars-post"
import "@modules/stars/styles-pc.css"
import "@modules/stars/stars-single-view-feedback.ts"
import "@modules/tracking/previous-next-advert-cookie"
import "@modules/util/Scrolling.ts"
import "@modules/_vendor/css/swiper.min.css"
import "@modules/../src/banner/muenchen/muenchen-auto-messe-pc.css"
import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"
import "@modules/util/LiveCharacterCounter"

import StarsPost from "@modules/stars/stars-post/StarsPost"
const posts = new StarsPost(this)

setAZMFilterPath()

posts.loadCurrentStarsPostsFilterForStarsProfile()
